const LOCAL_PART_PATTERN = /^[\p{L}\p{N}\p{M}.!$'*+\-\/_^`{|}~]+$/u;
const DOMAIN_LABEL_PATTERN = /^[\p{L}\p{N}](?:[\p{L}\p{N}\p{M}-]*[\p{L}\p{N}\p{M}])?$/u;

export function safeSupportEmail(value: unknown): string {
  const email = String(value ?? '').trim().toLowerCase();
  if (!email || email.length > 255 || /[\x00-\x20\x7f?#%&=,:;]/.test(email)) return '';
  const parts = email.split('@');
  if (parts.length !== 2 || !LOCAL_PART_PATTERN.test(parts[0])) return '';
  if (parts[0].startsWith('.') || parts[0].endsWith('.') || parts[0].includes('..')) return '';
  const domainLabels = parts[1].split('.');
  return domainLabels.length >= 2 && domainLabels.every((label) => DOMAIN_LABEL_PATTERN.test(label)) ? email : '';
}

export function supportMailto(value: unknown): string {
  const email = safeSupportEmail(value);
  if (!email) return '';
  const separator = email.lastIndexOf('@');
  const local = encodeURIComponent(email.slice(0, separator));
  const domain = encodeURIComponent(email.slice(separator + 1));
  return `mailto:${local}@${domain}`;
}
